import InvoiceActionTypes from './types';

export const changeInvoiceView = (view) => ({
  type: InvoiceActionTypes.SELECT_VIEW,
  payload: view,
});
